import React from "react";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";
import {FL_DESCRIPTION, FL_LONG_DESCRIPTION, FL_TITLE} from "../../../components/i18n/formLabels";
import {LangController} from "../../../components/tabs/langController";
import {PH_DESCRIPTION, PH_LONG_DESCRIPTION, PH_TITLE} from "../../../components/i18n/placeHolders";

const AybCategoryLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name, showOrder: lang?.showOrder },
            image:'',
            longDescription:'',
        }) )
        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md="12">
                <FormGroup>
                    <Label >{ FL_TITLE }</Label>
                    <Input type="text"
                           name="title"
                           placeholder={ PH_TITLE }
                           value= { child.title }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label >{ FL_DESCRIPTION }</Label>
                    <Input type="textarea"
                           name="shortDescription"
                           placeholder={ PH_DESCRIPTION }
                           value= { child.shortDescription }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label >{ FL_LONG_DESCRIPTION }</Label>
                    <Input type="textarea"
                           rows={"6"}
                           name="longDescription"
                           placeholder={ PH_LONG_DESCRIPTION }
                           value= { child.longDescription }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>


    return(<LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />)
}

export default AybCategoryLangs